<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
  methods: {}
};
</script>

<style lang="scss">
@import "@/core/themes/grid/grid-system.scss";
// @import "@/core/themes/preload/sidebar.scss";
@import "@/core/themes/base.scss";
// @import "@/core/themes/flag.scss";
</style>
